var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFilesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.332,
    height: 58.635,
    viewBox: "0 0 65.332 58.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8902",
    "data-name": "Group 8902",
    transform: "translate(-0.006 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28379",
    "data-name": "Path 28379",
    d: "M242.442,99.193l-2.126.548-26.19,6.754-2.126.548a4.025,4.025,0,0,0-2.889,4.9l9.218,35.745a4.025,4.025,0,0,0,4.9,2.889h.005l30.431-7.847h.005a4.025,4.025,0,0,0,2.889-4.9l-9.218-35.745A4.025,4.025,0,0,0,242.442,99.193Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28380",
    "data-name": "Path 28380",
    d: "M255.428,113.01l-2.518.649L227.5,120.211l-2.518.649a2.866,2.866,0,0,0-2.057,3.487l9.218,35.745a2.866,2.866,0,0,0,3.487,2.057h.005L266.07,154.3h.006a2.866,2.866,0,0,0,2.057-3.487l-9.218-35.745A2.866,2.866,0,0,0,255.428,113.01Z",
    transform: "translate(-221.675 -111.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28381",
    "data-name": "Path 28381",
    d: "M412.131,238.105l-15.394,3.97a.669.669,0,0,1-.334-1.3l15.394-3.97a.669.669,0,1,1,.334,1.3Z",
    transform: "translate(-380.279 -225.276)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28382",
    "data-name": "Path 28382",
    d: "M421.559,256.04,403.49,260.7a.67.67,0,0,1-.334-1.3l18.068-4.659a.669.669,0,0,1,.334,1.3Z",
    transform: "translate(-386.469 -241.713)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28383",
    "data-name": "Path 28383",
    d: "M442.4,355.479,427,359.448a.669.669,0,1,1-.334-1.3l15.394-3.97a.669.669,0,1,1,.334,1.3Z",
    transform: "translate(-408.018 -332.844)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28384",
    "data-name": "Path 28384",
    d: "M451.827,373.415l-18.068,4.659a.67.67,0,1,1-.334-1.3l18.068-4.659a.67.67,0,1,1,.334,1.3Z",
    transform: "translate(-414.208 -349.282)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28385",
    "data-name": "Path 28385",
    d: "M472.668,472.852l-15.394,3.97a.67.67,0,1,1-.334-1.3l15.394-3.97a.67.67,0,0,1,.334,1.3Z",
    transform: "translate(-435.759 -440.412)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28386",
    "data-name": "Path 28386",
    d: "M482.1,490.788l-18.068,4.659a.67.67,0,1,1-.334-1.3l18.068-4.659a.669.669,0,0,1,.334,1.3Z",
    transform: "translate(-441.948 -456.849)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28387",
    "data-name": "Path 28387",
    d: "M296.574,288.678l-5.448,1.4a.321.321,0,0,1-.391-.231L289.484,285a.321.321,0,0,1,.231-.391l5.448-1.4a.321.321,0,0,1,.391.231l1.251,4.849A.321.321,0,0,1,296.574,288.678Z",
    transform: "translate(-282.744 -267.809)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28388",
    "data-name": "Path 28388",
    d: "M326.842,406.051l-5.448,1.4a.321.321,0,0,1-.391-.231l-1.251-4.849a.321.321,0,0,1,.231-.391l5.448-1.4a.321.321,0,0,1,.391.231l1.251,4.849A.321.321,0,0,1,326.842,406.051Z",
    transform: "translate(-310.484 -375.377)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28389",
    "data-name": "Path 28389",
    d: "M357.11,523.425l-5.448,1.4a.321.321,0,0,1-.391-.231l-1.251-4.849a.321.321,0,0,1,.231-.391l5.448-1.4a.321.321,0,0,1,.391.231l1.251,4.849A.321.321,0,0,1,357.11,523.425Z",
    transform: "translate(-338.223 -482.945)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28390",
    "data-name": "Path 28390",
    d: "M474.651,209.052H443.213a4.025,4.025,0,0,0-4.02,4.02v36.914a4.025,4.025,0,0,0,4.02,4.02h31.438a4.025,4.025,0,0,0,4.02-4.02V213.072A4.025,4.025,0,0,0,474.651,209.052Z",
    transform: "translate(-419.955 -199.858)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28391",
    "data-name": "Path 28391",
    d: "M487.348,222.906H455.91a2.866,2.866,0,0,0-2.863,2.863v36.914a2.866,2.866,0,0,0,2.863,2.863h31.438a2.866,2.866,0,0,0,2.863-2.863V225.769A2.866,2.866,0,0,0,487.348,222.906Z",
    transform: "translate(-432.652 -212.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2242",
    "data-name": "Ellipse 2242",
    cx: 7.339,
    cy: 7.339,
    r: 7.339,
    transform: "translate(50.659 43.962)",
    fill: "purple"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28392",
    "data-name": "Path 28392",
    d: "M857.674,663.125h-2.553v-2.553a.957.957,0,0,0-1.915,0v2.553h-2.553a.957.957,0,1,0,0,1.914h2.553v2.553a.957.957,0,0,0,1.915,0V665.04h2.553a.957.957,0,1,0,0-1.914Z",
    transform: "translate(-796.166 -612.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28393",
    "data-name": "Path 28393",
    d: "M625.252,451.027h-15.9a.67.67,0,1,1,0-1.339h15.9a.67.67,0,1,1,0,1.339Z",
    transform: "translate(-575.288 -420.391)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28394",
    "data-name": "Path 28394",
    d: "M628.014,478.074h-18.66a.669.669,0,1,1,0-1.339h18.66a.669.669,0,1,1,0,1.339Z",
    transform: "translate(-575.288 -445.178)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28395",
    "data-name": "Path 28395",
    d: "M625.252,572.24h-15.9a.669.669,0,1,1,0-1.339h15.9a.669.669,0,1,1,0,1.339Z",
    transform: "translate(-575.288 -531.478)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28396",
    "data-name": "Path 28396",
    d: "M628.014,599.288h-18.66a.669.669,0,1,1,0-1.339h18.66a.669.669,0,1,1,0,1.339Z",
    transform: "translate(-575.288 -556.266)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28397",
    "data-name": "Path 28397",
    d: "M508.828,443.059H503.2a.321.321,0,0,1-.321-.321V437.73a.321.321,0,0,1,.321-.321h5.626a.321.321,0,0,1,.321.321v5.008A.321.321,0,0,1,508.828,443.059Z",
    transform: "translate(-478.323 -409.138)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28398",
    "data-name": "Path 28398",
    d: "M508.828,564.272H503.2a.321.321,0,0,1-.321-.321v-5.008a.321.321,0,0,1,.321-.321h5.626a.321.321,0,0,1,.321.321v5.008A.321.321,0,0,1,508.828,564.272Z",
    transform: "translate(-478.323 -520.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28399",
    "data-name": "Path 28399",
    d: "M671.286,316.092H659.565a.669.669,0,1,1,0-1.339h11.721a.669.669,0,1,1,0,1.339Z",
    transform: "translate(-621.304 -296.728)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28400",
    "data-name": "Path 28400",
    d: "M674.048,343.14H659.565a.669.669,0,1,1,0-1.339h14.483a.669.669,0,1,1,0,1.339Z",
    transform: "translate(-621.304 -321.517)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28401",
    "data-name": "Path 28401",
    d: "M513.8,291.049H502.991a.321.321,0,0,1-.321-.321V282.3a.321.321,0,0,1,.321-.321H513.8a.321.321,0,0,1,.321.321v8.433A.321.321,0,0,1,513.8,291.049Z",
    transform: "translate(-478.13 -266.688)",
    fill: "purple"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFilesIcon);
export default __webpack_public_path__ + "static/media/upload-files-icon.2835d036925d5b89db58eaadacfe7367.svg";
export { ForwardRef as ReactComponent };